import { render, staticRenderFns } from "./corNet.vue?vue&type=template&id=54adddcc&scoped=true&"
import script from "./corNet.vue?vue&type=script&lang=js&"
export * from "./corNet.vue?vue&type=script&lang=js&"
import style0 from "./corNet.vue?vue&type=style&index=0&id=54adddcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54adddcc",
  null
  
)

export default component.exports